import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=18b943c6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18b943c6"]])

export default __exports__